import { useEffect, useState } from 'react';

import Error404DarkImage from 'assets/images/404ErrorDark.svg';
import Error404LightImage from 'assets/images/404ErrorLight.svg';
import { ErrorPage } from 'components/error/ErrorPage';
import { useTranslation } from 'hooks/useTypedTranslation';
import { logEventInObservability as logEvent } from 'lib/observability';

const Error404 = () => {
  const { t } = useTranslation('common');
  const title = t('404: Page not found');

  const [isDarkMode, setIsDarkMode] = useState<boolean>();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    setIsDarkMode(document.documentElement.classList.contains('dark'));
    setIsReady(true);
  }, []);

  useEffect(() => {
    logEvent('404_page', { path: window.location.pathname });
  }, []);

  if (!isReady) return null;

  return (
    <ErrorPage
      image={isDarkMode ? Error404DarkImage.src : Error404LightImage.src}
      title={title}
      text={t("We can't find the page you're looking for, but we can help you get back on track.")}
    />
  );
};

export default Error404;
